// The KFintech website monitoring SDK (@kfintech/website-monitoring-sdk) is loaded as a
// plain script: the prestart/prebuild scripts in package.json copy its browser build into public/monitoring
// before start/build, and public/index.html includes it.

type MonitoringEnv = 'dev' | 'qa' | 'uat' | 'prod';

interface MonitoringConfig {
  appName: string;
  env: MonitoringEnv;
  apiUrl: string;
  version?: string;
  enableClicks?: boolean;
  enableVitals?: boolean;
  enableErrors?: boolean;
  enableMemory?: boolean;
  sampleRate?: number;
  maskKeys?: string[];
}

declare global {
  interface Window {
    KfintechWebMonitoringSDK?: {
      initMonitoring: (config: MonitoringConfig) => void;
    };
  }
}

// The same build is deployed to every environment (see .gitlab-ci.yml),
// so the environment is resolved from the hostname at runtime.
const resolveEnv = (): MonitoringEnv => {
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host.includes('dev')) return 'dev';
  if (host.includes('uat')) return 'uat';
  if (host.includes('qa') || host.includes('sit')) return 'qa';
  return 'prod';
};

export const setupMonitoring = (): void => {
  try {
    // The SDK only reports events when env is 'prod'.
    window.KfintechWebMonitoringSDK?.initMonitoring({
      appName: 'PMS',
      env: resolveEnv(),
      apiUrl: '/Analysis/WebsiteMonitoringSaving',
      enableClicks: false,
      enableErrors: true,
      enableVitals: true,
      sampleRate: 0.3,
      maskKeys: ['password', 'token', 'pan', 'aadhaar', 'otp'],
    });
  } catch (err) {
    console.error('Monitoring init failed', err);
  }
};
